import { AxiosResponse } from 'axios';
import { IUsersLocations } from 'types/location';
import { CompanyRoleEnum, RoleEnum, TokenPayload, UserEmail, UserPayload } from 'types/user';

import APIService from '../apiUtils';
import ApiEndpoint from './apiEndpoint';

export interface IAuthInviteUser {
  email: string;
  role?: RoleEnum | CompanyRoleEnum;
  companyRole?: CompanyRoleEnum;
  serviceTypes?: { id: string }[];
  company?: { name: string };
  firstName?: string;
  lastName?: string;
  usersLocations?: Partial<IUsersLocations> & { location: string }[];
}

export default class AuthService {
  static signInWithEmailPassword(reqBody: UserPayload): Promise<AxiosResponse<UserPayload>> {
    return APIService.post<UserPayload>(ApiEndpoint.signIn, {
      email: reqBody.email,
      password: reqBody.password,
    });
  }

  static resetPassword(reqBody: UserEmail): any {
    return APIService.post<UserEmail>(ApiEndpoint.resetPassword, {
      email: reqBody.email,
    });
  }

  static inviteUser(reqBody: IAuthInviteUser): any {
    return APIService.post<UserEmail>(ApiEndpoint.inviteUser, {
      ...reqBody,
    });
  }

  static reInviteUser(reqBody: IAuthInviteUser): any {
    return APIService.post<UserEmail>(ApiEndpoint.reInviteUser, {
      ...reqBody,
    });
  }

  static verifyToken(reqBody: TokenPayload): Promise<AxiosResponse<{ message: string; email: string }>> {
    return APIService.post<TokenPayload, AxiosResponse<{ message: string; email: string }>>(
      ApiEndpoint.verifyToken,
      reqBody,
    );
  }

  static getNewAccessToken(): Promise<AxiosResponse<any>> {
    return APIService.post<string, AxiosResponse<any>>(ApiEndpoint.getNewAccessToken);
  }

  static logout(): Promise<AxiosResponse<any>> {
    return APIService.post<string, AxiosResponse<any>>(ApiEndpoint.signOut);
  }
}
